import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { MapPin, Star, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { FavoriteButton } from "@/components/FavoriteButton";
import { popularDestinations } from "@/data/destinations";

export function Destinations() {
  return (
    <section id="destinations" className="py-20 bg-background relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-secondary/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <Badge variant="outline" className="mb-4 border-primary/20 text-primary px-4 py-1">
            Explore Paradise
          </Badge>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-primary mb-6">
            Popular Destinations
          </h2>
          <p className="text-muted-foreground text-lg">
            From ancient ruins to misty mountains, discover the diverse landscapes that make Sri Lanka unique.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {popularDestinations.map((dest) => (
            <Card key={dest.place_id} className="group overflow-hidden border-none shadow-lg hover:shadow-2xl transition-all duration-300 bg-white">
              <div className="relative h-64 overflow-hidden">
                <FavoriteButton
                  place={{
                    place_id: dest.place_id,
                    name: dest.name,
                    image: dest.image,
                    location: dest.location,
                  }}
                />
                <img
                  src={dest.image}
                  alt={dest.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute top-4 right-16 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full flex items-center gap-1 text-sm font-medium text-primary shadow-sm">
                  <Star className="w-4 h-4 fill-secondary text-secondary" />
                  {dest.rating}
                </div>
                <div className="absolute top-4 left-4">
                  <Badge className="bg-primary/90 hover:bg-primary text-white border-none">
                    {dest.category}
                  </Badge>
                </div>
              </div>

              <CardContent className="p-6">
                <div className="flex items-center gap-2 text-muted-foreground text-sm mb-3">
                  <MapPin className="w-4 h-4 text-secondary" />
                  {dest.location}
                </div>
                <h3 className="text-2xl font-serif font-bold text-primary mb-2 group-hover:text-secondary transition-colors">
                  {dest.name}
                </h3>
                <p className="text-muted-foreground mb-2 line-clamp-2">
                  {dest.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/plan-trip">
            <Button size="lg" className="bg-primary text-white hover:bg-primary/90 rounded-full px-8" data-testid="view-all-destinations">
              View All Destinations
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
